import { format } from "date-fns";

export const CASE_DETAIL_HEADER = [
  {
    value: 'case_id',
    label: 'Case ID',
  },
  {
    value: 'patient_id',
    label: 'Patient ID',
  },
  {
    value: '',
    label: 'BI Only',
  },
  {
    value: 'qty',
    label: 'Qty',
  },
  {
    value: '',
    label: 'Refills',
  },
  {
    value: 'received',
    label: 'Received',
  },
  {
    value: 'bi_completed',
    label: 'BI Completed',
  },
  {
    value: '',
    label: 'Transferred',
  },
  {
    value: '',
    label: 'Scheduled',
  },
  {
    value: '',
    label: 'Shipped',
  },
  {
    value: '',
    label: 'Pharmacy',
  },
  {
    value: 'payer',
    label: 'Payer',
  },
  {
    value: 'case_status',
    label: 'Case Status',
  },
  {
    value: '',
    label: 'Rx Cvge',
  },
  {
    value: '',
    label: 'Clinicals Received',
  },
  {
    value: '',
    label: 'Rx PA',
  },
  {
    value: 'prescriber',
    label: 'Prescriber',
  },
];

export const ONGOING_TREATMENTS_HEADER = [
  {
    value: 'case_id',
    label: 'Case Id',
  },
  {
    value: 'patient_id',
    label: 'Patient ID',
  },
  {
    value: 'Bi',
    label: 'BI #',
  },
  {
    value: 'qty',
    label: 'Qty',
  },
 
  {
    value: 'Prevous_treatment_date',
    label: 'Prevous Treatment Date',
  },
  {
    value: 'payer',
    label: 'Payer',
  },
  {
    value: '',
    label: 'Outcome',
  },
  {
    value: '',
    label: 'Rx Cvge',
  },
  {
    value: '',
    label: 'Med Cvge',
  },
  {
    value: '',
    label: 'Rx PA',
  },
  {
    value: '',
    label: 'Med PA',
  },
  {
    value: 'case_status',
    label: 'Case Status',
  },
  {
    value: '',
    label: 'Type',
  },
  {
    value: 'provider',
    label: 'provider',
  },
];


export const PROVIDER_PRACTICES_HEADER = [
  {
    value: '',
    label: 'Name',
  },
  // {
  //   value: '',
  //   label: 'Commercial',
  // },
  // {
  //   value: '',
  //   label: 'Medicare',
  // },
  // {
  //   value: '',
  //   label: 'Medicare advantage',
  // },
 
  // {
  //   value: '',
  //   label: 'Unspecified',
  // },
  {
    value: '',
    label: 'Cases',
  },
  
];

export const GROUP_BY_FILTER = [
  { value: "day", label: "Daily" },
  { value: "week", label: "Weekly" },
  { value: "month", label: "Monthly" },
  { value: "quarter", label: "Quarterly" },
];

export const COMPARISON_FILTER = [
  { value: "p-1", label: "vs Previous Period" },
  { value: "y-1", label: "vs Previous Year" },
]

export const CASE_FITLER = [
  { value: "all", label: "All Cases" },
  { value: "ecr", label: "ECR Cases" },
  { value: "ncr", label: "Non-ECR Cases" },
  { value: "par", label: "PA Pending" },
  { value: "doc", label: "Missing Docs" },
];

export const MANUFACTURER_DEFAULT_START_DATE = format(new Date().setDate(new Date().getDate() - 60), "yyyy-MM-dd");
export const MANUFACTURER_DEFAULT_END_DATE = format(new Date().setDate(new Date().getDate()+1), "yyyy-MM-dd");

export const HIDE_PATEINT_DOB_INITIALS = [
  "dyerves@mnkd.com",
  "freeman@mnkd.com",
  "mrowell@mnkd.com",
  "mhassman@mnkd.com",
  "wlepore@mnkd.com",
  "fsullivan@mnkd.com",
  "tsanft@mnkd.com",
  "hpereira@mannkindcorp.com",
  "ksears@mannkindcorp.com",
  "Tleonard@mannkindcorp.com",
  "Jmulroy@mnkd.com",
  "kbooth@mnkd.com",
  "zheim@mannkindcorp.com",
  "jswanson@mannkindcorp.com",
  "dhiday@mannkindcorp.com",
  "jemrich@mannkindcorp.com",
  "sczhang@mnkd.com",
];
